import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	effect,
	input,
	signal,
	untracked,
} from '@angular/core';

import { CommonImgDirective } from '~ng-common-lib/cdk/img';

@Component({
	selector: 'img-with-fallback',
	templateUrl: './img-with-fallback.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, CommonImgDirective],
	host: {
		class: 'block',
	},
})
export class ImgWithFallbackComponent {
	public readonly $renderImage = signal(true);
	public readonly $src = input<string | null | undefined>(null, { alias: 'src' });
	public readonly $imgClasses = input<string | null>(null, { alias: 'imgClasses' });

	constructor() {
		effect(() => {
			const src = (this.$src() ?? '').trim();

			untracked(() => {
				const renderImage = src !== '';
				this.$renderImage.set(renderImage);
			});
		});
	}

	public onError(): void {
		this.$renderImage.set(false);
	}
}
